import { render, staticRenderFns } from "./viewPHPCustom.vue?vue&type=template&id=79e123c8&scoped=true&"
import script from "./viewPHPCustom.vue?vue&type=script&lang=js&"
export * from "./viewPHPCustom.vue?vue&type=script&lang=js&"
import style0 from "./viewPHPCustom.vue?vue&type=style&index=0&id=79e123c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e123c8",
  null
  
)

export default component.exports